// import TicketMenuManagementCreate from "./lib/create";
import ErpTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';

import * as S from './styles';

export default function ErpPage() {
  const { list }: any = useTypedSelector((state) => state.Erp);

  console.log(list);

  return (
    <S.Container>
      <S.Head>
        <S.Title>ERP</S.Title>
      </S.Head>
      <Gap size="20px" />
      <ErpTable data={list.data} loading={list.loading} />

      <AppLoading loading={list.loading} />
    </S.Container>
  );
}
